import _ from "lodash";
import React from "react";
import classes from "./ValueComponent.scss";
import { CancelIcon } from "SvgComponents";
import { colors } from "Constants";
import { onEnterOrSpaceKeyDown } from "Utils";

const ValueComponent = ({ data }) => {
  const { id, children, disabled, onClick, onRemove, value } = data;
  const colorValue = colors[_.get(value, "color", "")];

  const containerStyle = {
    backgroundColor: colorValue ? `${colorValue}1A` : "",
    padding: disabled ? "0 12px 0 12px" : "0 0 0 12px",
  };
  const handleOnMouseDown = e => {
    e.stopPropagation();
    onRemove(value);
  };
  const handleOnTouchEnd = e => {
    e.stopPropagation();
    e.preventDefault();
    onRemove(value);
  };

  const handleClick = e => {
    e.stopPropagation();
    onRemove(value);
  };
  const handleRemoveKeyDown = e => {
    onEnterOrSpaceKeyDown(e, () => {
      e.stopPropagation();
      onRemove(value);
    });
  };
  const renderRemoveButton = (
    <div
      className={classes.removeButton}
      onMouseDown={handleOnMouseDown}
      onTouchEnd={handleOnTouchEnd}
      onClick={handleClick}
      tabIndex={0}
      onKeyDown={handleRemoveKeyDown}
    >
      <CancelIcon width={8} height={8} fill={colors.neutral500} />
    </div>
  );

  return (
    <div className={classes.container} style={containerStyle}>
      <div className={classes.itemContainer}>
        <div className={classes.labelContainer}>
          <div
            className={classes.labelText}
            style={colorValue ? { color: colorValue } : {}}
          >{`${value.label}`}</div>
        </div>
        {!disabled && renderRemoveButton}
      </div>
    </div>
  );
};

export default ValueComponent;
